export default __webpack_public_path__ + "static/media/logo.4b8c6857.svg";